var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar53(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18567 0.813474C3.28461 0.508976 3.71539 0.508977 3.81433 0.813475L4.2116 2.03614C4.25584 2.17231 4.38274 2.26451 4.52593 2.26451H5.81151C6.13168 2.26451 6.2648 2.67421 6.00577 2.8624L4.96572 3.61805C4.84988 3.70221 4.80141 3.85139 4.84565 3.98756L5.24292 5.21022C5.34186 5.51472 4.99335 5.76793 4.73432 5.57974L3.69427 4.82409C3.57843 4.73993 3.42157 4.73993 3.30573 4.82409L2.26568 5.57974C2.00665 5.76793 1.65814 5.51472 1.75708 5.21022L2.15435 3.98756C2.19859 3.85139 2.15012 3.70221 2.03428 3.61805L0.994226 2.8624C0.735205 2.67421 0.868324 2.26451 1.18849 2.26451H2.47407C2.61726 2.26451 2.74416 2.17231 2.7884 2.03614L3.18567 0.813474Z",
    fill: "url(#paint0_linear_23_318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_318",
    x1: 3.5,
    y1: -0.153931,
    x2: 3.5,
    y2: 6.84607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E732A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFD09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8641"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar53);
export default __webpack_public_path__ + "static/media/star53.1ba59d59adb5e2ad87ec3bd29b8df9b4.svg";
export { ForwardRef as ReactComponent };